import { ImageScaleAndCropComponent } from "./imageScaleAndCropComponent";
import { IoMdInformationCircle } from "react-icons/io";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState } from "react";
import styles from "../styles/settingsGeneralDetails.module.css";

// Component for handling image fields (Thumbnail, Display Image)
export const SettingsImageField = ({
    title,
    value,
    formData,
    setFormData,
    description,
    dims,
    height
  }: {
    title: string;
    value: string;
    formData: any;
    setFormData: any;
    description: string;
    dims:string;
    height:string;
  }) => {
    const [isCropVisible, setIsCropVisible] = useState(false);
    const [imageSrc, setImageSrc] = useState<string | null>(null);
  
    const handleFileChange = (e: any) => {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        setImageSrc(URL.createObjectURL(file));
        setIsCropVisible(true); // Show cropping modal
      }
    };
  
    const handleImageCropped = async (croppedImageUrl: any) => {
      setIsCropVisible(false); // Hide cropping modal after cropping
  
      // Convert cropped image URL to File object
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const fileExt = blob.type.split("/")[1];
      const fileName = `cropped_image.${fileExt}`;
      const croppedImageFile = new File([blob], fileName, { type: blob.type });
  
      // Update formData with the cropped image
      setFormData({
        ...formData,
        [value]: croppedImageFile,
      });
    };

    //placeholder image area is 265x265 which is fine for squares, but scaled now for width and height differences

    const placeHolderHeight = parseFloat(height)/parseFloat(dims)*265;
  
    return (
      <div className={styles.thumbnailWrapper}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <h4 className={styles.innerHead}>{title}</h4>
          {description && (
            <OverlayTrigger key="info" placement="top" overlay={<Tooltip id={`tooltip-info`}>{description}</Tooltip>}>
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 20,
                }}
              >
                <IoMdInformationCircle />
                {/* Using Font Awesome icon */}
              </button>
            </OverlayTrigger>
          )}
        </div>
        <div
          style={{
            margin: "0 auto 10px auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {formData[value] instanceof File  || formData[value] ?
          <img
            src={
              formData[value] && formData[value] instanceof File
                ? URL.createObjectURL(formData[value])
                : formData[value] || `https://via.placeholder.com/${dims}`
            }
            alt={title.toLowerCase()}
            style={{height: placeHolderHeight, width:265, objectFit:"cover"}}
          />
          :
          <div className={styles.imagePlaceHolder} style={{height: placeHolderHeight}}>
            <h3>
            {dims} x {height}
            </h3>
          </div>
          } 
        </div>
  
        <div style={{display: "flex"}}>
          <input type="file" onChange={handleFileChange} accept="image/png, image/jpeg, image/jpg" />
        </div>
        {/* Conditionally render ImageCropComponent */}
        {isCropVisible && (
          // <ImageCropComponent
          //   src={imageSrc}
          //   isVisible={isCropVisible}
          //   onImageCropped={handleImageCropped}
          //   dimensions={
          //     title === 'Avatar Image'
          //       ? {
          //           width: 256,
          //           height: 256,
          //         }
          //       : {
          //           width: 1092,
          //           height: 1080,
          //         }
          //   }
          // />
          <ImageScaleAndCropComponent
            setSrc={handleImageCropped}
            imageType={title === "Avatar Image" ? "avatar" : "displayImage"}
            src={imageSrc}
            handleClose={() => setIsCropVisible(false)}
            dimensions={title ==="Flyer Image"? {width: parseInt(dims), height:parseInt(height)}: {width:400, height:400}}
          />
        )}
        <p>Set the {title.toLowerCase()} image. Please select an image that is {dims} x {height}. Only *.png, *.jpg, and *.jpeg image files are accepted</p>
      </div>
    );
  };